import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import OneTimeProducts from "../PatientDashboard/components/OneTimeProducts";
import Products from "./components/Products";
import RecommendedDosageProvider from "src/context/RecommendedDosageProvider";

const Shop = () => {
  const { t } = useTranslation();
  const page = "shop";

  return (
    <Stack gap={3}>
      <Typography variant="h5" fontWeight={700}>
        {t(`${page}.header`, "Products")}
      </Typography>
      <Products productCategory="Weight Loss" />
      <Products productCategory="Birth Control" />
      <Products productCategory="Erectile Dysfunction" />
      <Products productCategory="Hair Loss" />
      <Products productCategory="Mental Health" />
      <Products productCategory="Nausea" />
      <Products productCategory="Skin Care" />
      <Products productCategory="Supplements" />
      <Products productCategory="Sleep" />
      <Products productCategory="Emergency Contraception" />
      <RecommendedDosageProvider>
        <OneTimeProducts />
      </RecommendedDosageProvider>
    </Stack>
  );
};

export default Shop;
